import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/views/homepage'
import Garment from '@/views/garment'
import Fabric from '@/views/fabric'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/homepage',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/garment',
      name: 'Garment',
      component: Garment
    },
    {
      path: '/fabric',
      name: 'Fabric',
      component: Fabric
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js